export const ADMINVERSION = "1.0.6";
